import React from 'react';
import Icon from '../../../AppIcon';

const RoleSelector = ({ currentRole, onRoleChange, availableRoles }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-foreground">Switch Role</h3>
        <Icon name="Users" size={16} className="text-muted-foreground" />
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-2">
        {availableRoles?.map((role) => (
          <button
            key={role?.id}
            onClick={() => onRoleChange(role?.id)}
            className={`flex items-center space-x-2 p-3 rounded-md text-sm font-medium transition-all duration-200 ${
              currentRole === role?.id
                ? 'bg-primary text-primary-foreground shadow-sm'
                : 'bg-muted text-muted-foreground hover:bg-muted/80 hover:text-foreground'
            }`}
          >
            <Icon name={role?.icon} size={16} />
            <span className="truncate">{role?.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default RoleSelector;